import cn from 'classnames';
import { useDispatch, useSelector } from 'react-redux';

import { setBadgeCount } from '../../../../store/actions/index.ts';
import { GlobalState } from '../../../../store/types.ts';
import Badge from './components/Badge/index.tsx';

import './style.scss';

// import closeLauncherImg from '../../../../assets/clear-button.svg';
import openLauncherImg from '../../../../assets/launcher_button.svg';

type Props = {
  toggle: () => void;
  chatId: string;
  openLabel: string;
  closeLabel: string;
  closeImg?: string;
  openImg?: string;
  showBadge?: boolean;
}

function Launcher({ toggle, chatId, openImg, closeImg, openLabel, closeLabel, showBadge }: Props) {
  const dispatch = useDispatch();
  const { showChat, badgeCount } = useSelector((state: GlobalState) => ({
    showChat: state.behavior.showChat,
    badgeCount: state.messages.badgeCount
  }));

  const toggleChat = () => {
    toggle();
    if (!showChat) dispatch(setBadgeCount(0));
  }

  return (
    !showChat && (
      <button type="button" className={cn('rcw-launcher')} onClick={toggleChat} aria-controls={chatId}>
        {showBadge && <Badge badge={badgeCount} />}
        <img src={openImg || openLauncherImg} className="rcw-open-launcher" alt={closeLabel} />
      </button>
    )
    // <button type="button" className={cn('rcw-launcher', { 'rcw-hide-sm': showChat })} onClick={toggleChat} aria-controls={chatId}>
    //   {!showChat && showBadge && <Badge badge={badgeCount} />}
    //   {showChat ?
    //     <img src={closeImg || closeLauncherImg} className="rcw-close-launcher" alt={openLabel} /> :
    //     <img src={openImg || openLauncherImg} className="rcw-open-launcher" alt={closeLabel} />
    //   }
    // </button>
  );
}

export default Launcher;
